import { useEffect, useState, useRef, useContext } from "react";
import { toast } from "react-toastify";

import api from "../../../BrandOnBoarding/api";
import { DiscoveryContext } from "../discovery-context";
import { AuthContext } from "../../../context/auth-context";

export default function useHistory(type) {
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState([]);
  const [error, setError] = useState("");
  const [hasReachedEnd, setHasReachedEnd] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const abortCtrlRef = useRef();
  const inProgress =  useRef(false);;
  const discoveryCtx = useContext(DiscoveryContext);
  const { user } = useContext(AuthContext);
  const webSocketBaseURL = process.env.REACT_APP_ORCHESTRATOR_BASE_URL;

  useEffect(() => {
    if (abortCtrlRef.current) {
      abortCtrlRef.current.abort();
    }
    setHistory([]);
    setHasReachedEnd(false);
    setTotalCount(0);
    setTotalPages(0);
  }, [type]);


    async function getHistory(page = 1, limit = 5, searchQuery = "") {
    try {
      if (page == 1) {
        discoveryCtx.updateTransactionHistory({ clear: true })
      }
      setError("");
      setLoading(true);
      if (abortCtrlRef.current) {
        abortCtrlRef.current.abort();
      }
      const abortCtrl = new AbortController();
      abortCtrlRef.current = abortCtrl;
      
      const params = { page, limit };
      if (searchQuery && searchQuery.trim()) {
        params.search = searchQuery.trim();
      }
      
      const response = await api.get(
        `${webSocketBaseURL}/getUserIdHistory/discovery/${type}/${user?.user_role?.user_id}`,
        {
          params,
          signal: abortCtrl.signal
        }
      );
      
      setLoading(false);
      
      if (response.status !== 200) {
        setError("Failed to fetch discovery")
        return;
      }
      
      let data;
      let count = 0;
      let pages = 0;
      
      if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
        data = response.data.data || response.data.records || [];
        count = response.data.totalCount || response.data.total || 0;
        pages = response.data.totalPages || Math.ceil(count / limit) || 0;
      } else {
        data = response.data || [];
        count = data.length; // Fallback: use current data length
        pages = Math.ceil(count / limit);
      }
      
      setTotalCount(count);
      setTotalPages(pages);
      
      if (data.length === 0 || data.length < limit) {
        setHasReachedEnd(true);
      }
      
      discoveryCtx.updateTransactionHistory(data)
       return data
    } catch (error) {
      if (error.name === "CanceledError") {
        return;
      }
      setError("Failed to fetch discovery")
      setLoading(false);
      setTotalCount(0);
      setTotalPages(0);
    }
  }

    async function deleteHistory(id) {
    try {
      const response = await api.delete(`${webSocketBaseURL}/${id}`);
      if (response.status === 200) {
        discoveryCtx.updateTransactionHistory({
          replace: true,
          data: discoveryCtx.state.transactionHistory.filter(history => history.transactionId !== id)
        });
        setTotalCount(prev => Math.max(0, prev - 1));
        const limit = 5; // Use the same limit as getHistory
        setTotalPages(Math.ceil(Math.max(0, totalCount - 1) / limit));
      } else {
        toast.error("Failed to delete discovery");
      }
    } catch (error) {
      toast.error("Failed to delete discovery");
    }
  }

  return {
    loading,
    error,
    history,
    getHistory,
    setHistory,
    deleteHistory,
    hasReachedEnd,
    setHasReachedEnd,
    setLoading,
    totalCount,
    totalPages,
  };
}
